class DetailsModal extends HTMLElement {
  constructor() {
    super();
    // header-search jaise markup me <details>/<summary> nahi hote,
    // aise case me custom element khud hi container ban jayega
    this.detailsContainer = this.querySelector('details') || this;
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );

    if (this.summaryToggle) {
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      this.summaryToggle.setAttribute('role', 'button');
    }

    const closeButton = this.querySelector('button[type="button"]');
    if (closeButton) closeButton.addEventListener('click', this.close.bind(this));

    // overlay pe click => modal close (agar overlay element ho to)
    const overlay = this.querySelector('.modal-overlay');
    if (overlay) overlay.addEventListener('click', () => this.close(false));
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const focusTarget = this.detailsContainer.querySelector('[tabindex="-1"]');
    const focusInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
    if (focusTarget && focusInput) trapFocus(focusTarget, focusInput);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle && this.summaryToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    if (this.onBodyClickEvent) document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);